import PropTypes from 'prop-types';
import {createUseStyles, useTheme} from 'react-jss';
import {connect} from 'react-redux';
import {skipToMainContent} from '../../../v2/actions/accessibilityActions';
import ArtemisFonts from '../../../v2/components/ui/ArtemisFonts';
import Translation from '../../../v2/lang/Translation';
import isUsingArtemisStyles from '../../../v2/selectors/isUsingArtemisStyles';
import Typography from '../../../v2/style-helper/Typography';
import bigQueryMetricRecorder from '../../../v2/tracking/bigQueryMetricRecorder';
import Track from '../../../v2/utils/tracking';

const useStyles = createUseStyles({
  skipLink: {
    fontSize: '1.2em',
    zIndex: 999,
    display: 'block',
    overflow: 'hidden',
    width: 0,
    height: 0,
    textAlign: 'center',
    boxShadow: 'inset 0 0 6px 0 #0079ff',
    textTransform: props => props.theme.sectionHeader.isUppercase && 'uppercase',
    background: '#fff',
    extend: props => ({
      ...(props.isUsingArtemisStyles && props.theme.typography?.[Typography.medium])
      && ArtemisFonts(props.theme.typography[Typography.medium]),
    }),
    
    '&:focus, &:active': {
      width: 'auto',
      height: 'auto',
      padding: 10,
    },
  },
});

export function SkipLink(props) {
  const theme = useTheme();
  const classes = useStyles({...props, theme});
  
  const handleClick = (event) => {
    event.preventDefault();
    props.skipToMainContent();
    
    try {
      bigQueryMetricRecorder('skipLink', [{name: 'event', value: 'click'}]);
    } catch (error) {
      Track.track(error);
    }
  };
  
  const handleFocus = () => {
    try {
      bigQueryMetricRecorder('skipLink', [{name: 'event', value: 'focus'}]);
    } catch (error) {
      Track.track(error);
    }
  };
  
  return (
    <a
      className={classes.skipLink}
      data-test="SkipLink"
      href="#main-content"
      onClick={handleClick}
      onFocus={handleFocus}
    >
      <Translation>accessibility.skip.main.content.link.text</Translation>
    </a>
  );
}

const mapStateToProps = state => ({
  isUsingArtemisStyles: isUsingArtemisStyles(state),
});

SkipLink.propTypes = {
  skipToMainContent: PropTypes.func.isRequired,
  isUsingArtemisStyles: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps, {skipToMainContent})(SkipLink);
